import { Injectable } from "@angular/core";
import { Shared, UserService } from "@rubii/frontend-common";

@Injectable()
export class VerificationService {
    verifyType: "mobile" | "email" = "email";
    redirectUrl: string = '';
    constructor(private userService: UserService) {
        const user = this.userService.user as any;
        const mobileIsVerified = user?.mobileVerified;
        const authPreference = user?.authPreference;
        this.verifyType = mobileIsVerified && authPreference === 'mobile' ? "mobile" : "email";
    }

    setRedirectUrl(url: string) {
        this.redirectUrl = url;
    }

    getRedirectUrl(): string {
        return this.redirectUrl;
    }

    gotoRedirectUrl() {
        if (!this.redirectUrl){
            this.exactLoginRedirect(false, this.userService.user, this.userService.getTrackerUrl());
        }
        window.location.href = this.redirectUrl;
    }

    exactLoginRedirect(isExternal: boolean, user: any, trackUrl: string) {
        if (isExternal) {
            this.setRedirectUrl(trackUrl + "/list");
        } else {
            Shared.helpers.CookieHelper.deleteCookie(
                "visited-" +
                user.tenant.id +
                "-" +
                user.id
            );
            let url = document.referrer;

            const isLockedUrl = url.toLowerCase().includes("lock");
            const isVerificationUrl = url.toLowerCase().includes("verification");
            if (
                (url.length === 0 ||
                    url.toLowerCase().indexOf("login") >= 0 ||
                    isLockedUrl ||
                    isVerificationUrl)
            ) {
                this.setRedirectUrl(trackUrl + "/list");
            } else {
                this.setRedirectUrl(url);
            }
        }
    }

    setCookieWithExpire(name: string, val: string, expireMs: number = 24 * 60 * 60 * 1000) {
        const date = new Date();
        const value = val;
        date.setTime(date.getTime() + expireMs);
        if(document!==undefined) {
            document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
        }
    }
}